"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathBackgroundColorHighOpacity = exports.getPathSelectedBackgroundColor = exports.getPathBackgroundColor = exports.getPathColor = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../legacy-editor-package/components/PathIcon/utils");
const BACKGROUND_OPACITY_LOW = 0.03;
const BACKGROUND_OPACITY_MED = 0.06;
const BACKGROUND_OPACITY_HIGH = 0.1;
exports.getPathColor = (node) => lodash_1.get(node, ['params', 'color']);
const getBackground = (opacity, color) => {
    const c = utils_1.getPathColorValue(color);
    return `rgba(${c.value.join(', ')}, ${opacity})`;
};
exports.getPathBackgroundColor = lodash_1.partial(getBackground, BACKGROUND_OPACITY_LOW);
exports.getPathSelectedBackgroundColor = lodash_1.partial(getBackground, BACKGROUND_OPACITY_MED);
exports.getPathBackgroundColorHighOpacity = lodash_1.partial(getBackground, BACKGROUND_OPACITY_HIGH);
